module.exports = "/static/assets/35e5b40c044bd4eb0fc7c261271453e5.png";